import {EquipmentEnums, EquipmentInterfaces} from '@namespaces/equipment.namespace';
import {ApiModel} from './api-model';

/**
 * Модель оборудования
 */
export class Equipment extends ApiModel<EquipmentInterfaces.Model> {
    public title: string;
    public groups: string[];
    public type: string;
    public isMaterial: boolean;
    public verificationInterval: number;
    public photoUrl: string;
    public application: string;
    public isModerated: boolean;

    /**
     * @param _rawData - Данные от API в исходном виде
     */
    constructor(
        _rawData: EquipmentInterfaces.Model
    ) {
        super(_rawData);
        this.setAttributes();
    }

    /**
     * Установить значения атрибутов из исходных данных
     */
    protected setAttributes() {
        this.title = this.rawData.title;
        this.groups = this.rawData.groups.map(item => item.title);
        this.type = this.rawData.type_title;
        this.isMaterial = this.rawData.type === EquipmentEnums.Type.material;
        this.verificationInterval = +this.rawData.verification_interval;
        this.photoUrl = this.rawData.images.length ? this.rawData.images[0].file_url : null;
        this.application = this.rawData.application;
        this.isModerated = this.rawData.is_moderated;
    }
}
